import FrontEndUsersIcon from '@material-ui/icons/SupervisedUserCircle';
import { resourceWrapper } from '../../Components/ui/utils';
import { ResourcePermissions } from '../../Providers/AppPermissionsProvider';
import { ResourceExport } from '../../types/resource-export.type';
import { PersonRoles } from '../../utils/constants';
import FrontEndUsersProfileModificationDetails from './FrontEndUsersProfileModificationDetails';
import FrontEndUsersProfileModificationList from './FrontEndUsersProfileModificationList';

const { Auctioneer } = PersonRoles;

export const FRONT_END_USERS_PROFILE_MODIFICATION_PERMISSIONS: ResourcePermissions = {
  canEdit: [],
  canShow: [Auctioneer],
  canCreate: [],
  canList: [Auctioneer],
};

const FrontEndUsersProfileModification: ResourceExport = {
  list: FrontEndUsersProfileModificationList,
  show: resourceWrapper(
    'show',
    FrontEndUsersProfileModificationDetails,
    undefined,
    undefined,
    FRONT_END_USERS_PROFILE_MODIFICATION_PERMISSIONS,
  ),
  edit: resourceWrapper(
    'edit',
    FrontEndUsersProfileModificationDetails,
    undefined,
    undefined,
    FRONT_END_USERS_PROFILE_MODIFICATION_PERMISSIONS,
  ),
  icon: FrontEndUsersIcon,
};

export default FrontEndUsersProfileModification;
